<template>
  <!--右侧树形展示所有停车场-->
  <div class="trees">
    <el-input class="search" placeholder="输入关键字" v-model="filterText"></el-input>
    <el-tree
      ref="tree"
      :data="allDatas"
      :props="defaultProps"
      @node-click="handleTreeClick"
      node-key="id"
      :highlight-current="true"
      :show-checkbox="false"
      :expand-on-click-node="true"
      :default-expanded-keys="nodeKeys"
      :filter-node-method="filterNode"
    >
      <span slot-scope="{node,data}" class="group">
        <span>
          <span class="group-name" v-if="data.type=='admin'">{{node.label}}</span>
          <span class="group-name" v-if="data.type=='group'">
            <span class="group-name-tip">集团</span>
            {{node.label}}
          </span>
          <span class="group-name" v-if="data.type=='property'">
            <span class="group-name-tip">物业</span>
            {{node.label}}
          </span>
          <span class="group-name" v-if="data.type=='parking'">
            <span class="group-name-tip">车场</span>
            {{node.label}}
          </span>
          <span class="group-name" v-if="data.type=='shops'">
            <span class="group-name-tip">商户</span>
            {{node.label}}
          </span>
        </span>
      </span>
    </el-tree>
  </div>
</template>
<script>
import { getDepartTree } from "@/api/url";
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
  data() {
    return {
      allDatas: [],
      showArea: false,
      showBox: false,
      showChannel: false,
      nodeKeys: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      filterText: "",
      dialogFormVisible: false,
      delDialogFormVisible: false,
      form: {
        id: "",
        type: "",
        parentId: "",
        name: "",
        person: "",
        phone: "",
      },
      delForm: {
        id: "",
        password: "",
      },
    };
  },
  props: {
    moduleName: String,
    areaId: String,
  },
  methods: {
    ...mapMutations(["getPage"]),
    getAllDatas: function () {
      var _this = this;
      this.$get(getDepartTree(), {}).then((data) => {
        // if(data.status!=200) return;
        if (this.moduleName == "shops") {
          this.allDatas = data;
        } else {
          let tempArray = new Array();
          let temp = this.getDataByType("parking", data[0]);
          tempArray[0] = temp;
          this.allDatas = tempArray;
        }
        this.allDatas.forEach(function (item) {
          _this.nodeKeys.push(item.id);
        });
      });
    },
    //点击树的节点展示相应数据
    handleTreeClick: function (node, data) {
      this.getPage({
        curIndex: 1,
        rowsCount: 0,
      });
      // console.log(node)
      this.$emit("handleTreeClick", node, data);
    },

    setCurrent(id) {
      this.$refs.tree.setCurrentKey(id);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    getDataByType(type, data) {
      if (!data) {
        return;
      }
      if (data.type != type) {
        if (!Array.isArray(data.children)) {
          return data;
        } else {
          const children = data.children
            .map((ele) => {
              return this.getDataByType(type, ele);
            })
            .filter((ele) => ele !== null);
          return {
            type: data.type,
            name: data.name,
            contact: data.contact,
            mobile: data.mobile,
            id: data.id,
            parentId: data.parentId,
            address: data.address,
            children,
          };
        }
      } else {
        return {
          type: data.type,
          name: data.name,
          contact: data.contact,
          mobile: data.mobile,
          id: data.id,
          parentId: data.parentId,
          address: data.address,
        };
      }
    },
    permiss() {
      this.property_btn_add = this.elements["property:btn_add"];
      this.property_btn_edit = this.elements["property:btn_edit"];
      this.property_btn_remove = this.elements["property:btn_remove"];
      this.grouplist_btn_add = this.elements["grouplist:btn_add"];
      this.grouplist_btn_edit = this.elements["grouplist:btn_edit"];
      this.grouplist_btn_remove = this.elements["grouplist:btn_remove"];
    },
  },
  created() {
    this.permiss();
  },
  mounted() {
    // this.getModuleName();
    // console.log(this.property_btn_add)
    this.getAllDatas();
  },
  computed: {
    ...mapState({
      elements: (state) => state.elements,
    }),
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
};
</script>
<style scoped>
.parkClass {
  display: inline-block;

  height: 15px;
  line-height: 15px;
  /*background-color:#278cd8;*/
  background: url(~@/assets/images/park.png) no-repeat left center;
  padding-left: 20px;
  /*font-weight: bold;*/
  color: #606266;
  font-size: 14px;
}
.areaClass {
  display: inline-block;
  line-height: 15px;
  height: 15px;
  /*background-color:#278cd8;*/
  background: url("~@/assets/images/area.png") no-repeat left center;
  padding-left: 20px;
}
.spaceClass {
  display: inline-block;
  width: 10px;
  height: 10px;
  /*background-color:#278cd8;*/
  background: url(~@/assets/images/space.png) no-repeat center center;
}
.el-tree {
  color: #5c5c5c !important;
  height: calc(100vh - 130px);
  overflow: auto;

  width: 100%;
}
.is-current {
  background: #afc0e9 !important;
}
.trees {
  border-right: 10px solid #eff2f7;
  padding: 10px 5px 0 5px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background: #ccc !important;
}

.isActive {
  background: #ccc !important;
}
.search {
  border-radius: 10px !important;
  margin-bottom: 10px;
}
.tree-tip {
  font-size: 10px;
  color: red;
}

.add {
  color: #409eff;
}
.edit {
  color: #67c23a;
}
.delete {
  color: #f56c6c;
}
.group-name-tip {
  color: red;
  font-size: 10px;
}
</style>
<style>
.trees .search .el-input__inner {
  border-radius: 4px;
}
</style>